import type { IButtonProps } from '@fluentui/react/lib/Button';
import {
    presentDiscardClosureConfirmation,
    popOutCompose,
} from 'owa-calendar-compose-form-actions';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { popoutsOpenInNewWindow_0 } from 'owa-locstrings/lib/strings/popoutsopeninnewwindow_0.locstring.json';
import { closeText } from 'owa-locstrings/lib/strings/closetext.locstring.json';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import getCalendarBarIconColor from 'owa-calendar-forms-common/lib/utils/getCalendarBarIconColor';

export function getButtonProps(
    colorScheme: ColorScheme,
    showFullScreen: boolean,
    showSchedulingAssistant: boolean
): IButtonProps[] {
    let style = {
        root: {
            fontSize: '17px',
            color: getCalendarBarIconColor(colorScheme),
        },
    };
    let buttons = [];
    const presentDiscardConfirmation = () => presentDiscardClosureConfirmation();
    if (!showSchedulingAssistant) {
        if (!showFullScreen) {
            buttons.push({
                onClick: () => popOutCompose(),
                iconProps: {
                    iconName: ControlIcons.OpenInNewWindow,
                    styles: style,
                },
                title: loc(popoutsOpenInNewWindow_0),
                ariaLabel: loc(popoutsOpenInNewWindow_0),
            });
            buttons.push({
                onClick: presentDiscardConfirmation,
                iconProps: {
                    iconName: ControlIcons.Cancel,
                    styles: style,
                },
                title: loc(closeText),
                ariaLabel: loc(closeText),
            });
        }
    }
    return buttons;
}
